import { useQuery } from '@tanstack/react-query'

import {
  searchTeamContactsEmail,
  searchTeamContactsMobile,
} from 'app/services/http/teams/contacts'

/**
 * Hook to search team contacts by email
 * @param teamId - The team ID
 * @param searchQuery - The email search query
 * @param options - Additional options for the query
 */
export const useEmailContactSearch = (
  teamId: string,
  searchQuery: string,
  options: any = {},
) => {
  const enabled =
    !!teamId && !!searchQuery?.trim() && searchQuery.trim().length >= 2

  return useQuery({
    queryKey: ['emailContacts', teamId, searchQuery],
    queryFn: async () => {
      const response = await searchTeamContactsEmail(teamId, searchQuery)
      // Transform response to match expected format
      return {
        data: response.contacts || [],
      }
    },
    enabled,
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
    ...options,
  })
}

/**
 * Hook to search team contacts by mobile
 * @param teamId - The team ID
 * @param searchQuery - The mobile search query
 * @param options - Additional options for the query
 */
export const useMobileContactSearch = (
  teamId: string,
  searchQuery: string,
  options: any = {},
) => {
  const enabled =
    !!teamId && !!searchQuery?.trim() && searchQuery.trim().length >= 2

  return useQuery({
    queryKey: ['mobileContacts', teamId, searchQuery],
    queryFn: async () => {
      const response = await searchTeamContactsMobile(teamId, searchQuery)
      // Transform response to match expected format
      return {
        data: response.contacts || [],
      }
    },
    enabled,
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
    ...options,
  })
}
